module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAAXNSR0IArs4c6QAAAGJJREFUKBVjdEtI/ccIBAxkACZyNYLsYvr///9XMiwFavn/jjx9A66L0S0xbR/Q/UykuoTxP8N/FmAcOTIwkBFTQC0k20iqCwehekb3xNS3wAATIsNt34ABRpZGkF1cFIU2AGw1EDGm3XtzAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-shared.png
// module id = 2019
// module chunks = 0